/* tslint:disable */
// TOTVS TypeScript translaton resource
// Reference date : 20261006

export const literalsEnUS = {
  str0001: "Purchases Module",
  str0002: "Purchase need",
  str0003: "Start",
  str0004: "Quotes",
  str0005: "Purchase order",
  str0006: "Purchases history",
  str0007: "Indicators",
  str0008: "Pending",
  str0009: "Partially met",
  str0010: "Met",
  str0011: "Select period",
  str0012: "Search by product code",
  str0013: "Advanced Search",
  str0014: "Exit",
  str0015: "Request",
  str0016: "Request item",
  str0017: "Product Code",
  str0018: "Product description",
  str0019: "Necessity date",
  str0020: "Unit of measurement",
  str0021: "Quantity",
  str0022: "Notes",
  str0023: "Attachments",
  str0024: "Requester",
  str0025: "Requester branch",
  str0026: "Delivery branch",
  str0027: "Cost center",
  str0028: "Ledger Account",
  str0029: "Accounting item",
  str0030: "Value class",
  str0031: "Group requests",
  str0032: "Start quotation",
  str0033: "Enter the request code",
  str0034: "Add requester",
  str0035: "Add product description",
  str0036: "Add requester branch",
  str0037: "Add delivery branch",
  str0038: "Add cost center",
  str0039: "Add ledger account",
  str0040: "Add accounting item",
  str0041: "Add value class",
  str0042: "Clear filters",
  str0043: "Apply filters",
  str0044: "Quotes",
  str0045: "Exit application?",
  str0046: "List of attachments",
  str0047: "Name",
  str0048: "Description",
  str0049: "Attachment",
  str0050: "Click to display the list of attachments",
  str0051: "Enter your user",
  str0052: "Enter your password",
  str0053: "Enter the desired alias",
  str0054: "My routines",
  str0055: "Get to know the routines",
  str0056: "Purchase order",
  str0057: "Purchase history",
  str0058: "Indicators",
  str0059: "Purchase requests.",
  str0060: "Routine for generating quotations based on the purchase requests registered. Get information from open, partially serviced, and serviced requests.",
  str0061: "Allows the updating, deletion, and analysis of quotations considering the best proposal among suppliers according to price, payment terms, and delivery term.",
  str0062: "It allows the maintenance of Purchase Orders generated according to the company's needs, representing a document that formalizes the purchase between the company and the supplier.",
  str0063: "Purchase Management",
  str0064: "Access",
  str0065: "Quotation request",
  str0066: "Quotation data",
  str0067: "Quotation group",
  str0068: "Quotation group nickname",
  str0069: "Quotation receipt",
  str0070: "Number of providers",
  str0071: "Delivery information",
  str0072: "EIN",
  str0073: "Company name",
  str0074: "Delivery address",
  str0075: "Attach files",
  str0076: "Only XML, PDF, Otcx files",
  str0077: "Size limit per file: up to 30 MB.",
  str0078: "Products requested",
  str0079: "Order",
  str0080: "Grouped requests",
  str0081: "This information is not sent to the provider.",
  str0082: "Product Code",
  str0083: "Product description",
  str0084: "Measurement unit",
  str0085: "Total qty",
  str0086: "Notes for the provider",
  str0087: "Record selected:",
  str0088: "Records selected:",
  str0089: "Record(s)",
  str0090: "Records",
  str0091: "No products requested",
  str0092: "Close",
  str0093: "Back to requests grouping",
  str0094: "Selection of Suppliers/Participants",
  str0095: "Next step",
  str0096: "New provider",
  str0097: "Hello,",
  str0098: "Logout successful!",
  str0099: "Yes",
  str0100: "No",
  str0101: "Cancel",
  str0102: "Selected Suppliers/Participants",
  str0103: "You haven't selected any supplier yet.",
  str0104: "The last suppliers are listed according to the most recent purchase invoices found for the products in this collection.",
  str0105: "Suggestion of suppliers",
  str0106: "Last suppliers",
  str0107: "All suppliers",
  str0108: "Busque por CNPJ, nome fantasia, razão social ou código...",
  str0109: "Showing",
  str0110: "from",
  str0111: "supplier suggestion",
  str0112: "suppliers suggestions",
  str0113: "Supplier code",
  str0114: "Store",
  str0115: "E-mail",
  str0116: "Phone number",
  str0117: "Group of products met",
  str0118: "group of products",
  str0119: "Group code",
  str0120: "Group description",
  str0121: "Products registered",
  str0122: "Without information",
  str0123: "Display details",
  str0124: "Update contacts",
  str0125: "Supplier details",
  str0126: "Filter without results",
  str0127: "Cancel this operation?",
  str0128: "Suppliers selected",
  str0129: "Change Branch",
  str0130: "SSN",
  str0131: "Load more results",
  str0132: "Enter group code",
  str0133: "Group",
  str0134: "Choose the branches group desired.",
  str0135: "Branch",
  str0136: "Enter branch desired.",
  str0137: "Replace branch",
  str0138: "These are all suppliers registered in the base.",
  str0139: "No branch selected.",
  str0140: "Number of suppliers selected larger than the maximum allowed.",
  str0141: "Generate Quotation",
  str0142: "(Required)",
  str0143: "Number of characters not valid",
  str0144: "Remove",
  str0145: "Enter group nickname of this quotation",
  str0146: "Select the maximum term for receiving quotations from providers.",
  str0147: "Invalid value",
  str0148: "Number of suppliers that will take part in the quotation.",
  str0149: "Download attachment",
  str0150: "Remove item from the list",
  str0151: "Selected items",
  str0152: "Supplier",
  str0153: "Address",
  str0154: "District",
  str0155: "Postal Code",
  str0156: "Company Name",
  str0157: "City",
  str0158: "State",
  str0159: "Confirm creation of purchase quotation?",
  str0160: "Finishing the quotation request",
  str0161: "Confirm",
  str0162: "Suppliers selected for the process:",
  str0163: "Country",
  str0164: "Invalid format",
  str0165: "Send quotation to providers by e-mail?",
  str0166: "Send attachments to the supplier?",
  str0167: "More Details",
  str0168: "Charts",
  str0169: "SC vs. PC",
  str0170: "View",
  str0171: "Purchases",
  str0172: "Delete attachment",
  str0173: "Actions",
  str0174: "Delete this attachment?",
  str0175: "Area Code",
  str0176: "Main e-mail",
  str0177: "Document type",
  str0178: "Evaluate overdue proposal?",
  str0179: "Select the document type",
  str0180: "Order",
  str0181: "Contract",
  str0182: "Select whether to evaluate the overdue proposal",
  str0183: "Submission of e-mails and attachments",
  str0184: "Cancel the submission of e-mails and attachments?",
  str0185: "Process successfully completed!",
  str0186: "An open quotation already exists for this purchase request!",
  str0187: "Drag a file or click here to select",
  str0188: "Maximum of 10MB per file",
  str0189: "Invalid password and/or username, check them and try again.",
  str0190: "In progress",
  str0191: "Failed",
  str0192: "Completed",
  str0193: "Delete attachment",
  str0194: "Delete attachment '{0}'? This action cannot be reversed.",
  str0195: "Deleting attachment...",
  str0196: "Attachment '{0}' deleted successfully!",
  str0197: "The format of file '{0}' is not accepted!",
  str0198: "The size of file '{0}' exceeds 10MB!",
  str0199: "On queue",
  str0200: "The filters are only applied to the view. All selected items will be kept.",
  str0201: "Filters applied",
  str0202: "See filters",
  str0203: "Quotations requested",
  str0204: "Quotation",
  str0205: "Alias",
  str0206: "Average time for delivery",
  str0207: "Status",
  str0208: "Pending",
  str0209: "Ready to analyze",
  str0210: "In analysis",
  str0211: "Completed",
  str0212: "Deleted",
  str0213: "Edit",
  str0214: "Analyze",
  str0215: "Continue analysis",
  str0216: "Preview",
  str0217: "quotations",
  str0218: "Delete quotation",
  str0219: "Reopen analysis",
  str0220: "Search by quotation number or nickname",
  str0221: "Menu option still under development!",
  str0222: "Invalid items found",
  str0223: "Error Message",
  str0224: "Cannot start a quotation",
  str0225: "Invalid items will not be considered when generating the quotation.",
  str0226: "Continue this quotation without the items described above?",
  str0227: "The quotation process was canceled.",
  str0228: "Cancel quotation",
  str0229: "This supplier was already selected!",
  str0230: "An issue was found when starting this quotation",
  str0231: "Cannot generate this quotation",
  str0232: "Edit quotation",
  str0233: "Details",
  str0234: "Partial",
  str0235: "Delete",
  str0236: "Quotation analysis",
  str0237: "Shipping Total",
  str0238: "Items Total",
  str0239: "Amount Payable",
  str0240: "Time for Delivery",
  str0241: "Formalize Purchase",
  str0242: "Quotation Details",
  str0243: "Quotation Total",
  str0244: "Items Pending",
  str0245: "Return",
  str0246: "Discounts",
  str0247: "Taxes",
  str0248: "Freight",
  str0249: "Payment Method",
  str0250: "Payment Term",
  str0251: "Disqualify Supplier",
  str0252: "Send e-mail",
  str0253: "Note",
  str0254: "Delivery",
  str0255: "Products Requested",
  str0256: "Quantity Requested",
  str0257: "Available Quantity",
  str0258: "Unit value",
  str0259: "Total value",
  str0260: "Primary Criterion",
  str0261: "Total Value",
  str0262: "Unit Value",
  str0263: "Best Price",
  str0264: "Shortest Term",
  str0265: "Highest Score",
  str0266: "Filters",
  str0267: "Discounts",
  str0268: "Taxes",
  str0269: "Total value of quotation",
  str0270: "Discounts applied",
  str0271: "Shipping Type",
  str0272: "Payment Term",
  str0273: "CIF",
  str0274: "FOB",
  str0275: "By third parties",
  str0276: "By Sender",
  str0277: "Recipient",
  str0278: "No Shipping",
  str0279: "Payment Details",
  str0280: "Item Shipping",
  str0281: "Item Total",
  str0282: "Delivery date",
  str0283: "Delivery address",
  str0284: "Consider item",
  str0285: "Discount",
  str0286: "Save",
  str0287: "Quotations",
  str0288: "Loading",
  str0289: "De-qualify",
  str0290: "Updating quotation",
  str0291: "Completed",
  str0292: "Save attachment(s)",
  str0293: "Send E-mail(s)",
  str0294: "City",
  str0295: "Freight type",
  str0300: "Days for delivery",
  str0301: "View",
  str0302: "Qualify",
  str0303: "De-qualify",
  str0304: "Other actions",
  str0305: "Quotation data:",
  str0306: "Viewing quotation:",
  str0307: "Consider item",
  str0308: "Enter the payment condition.",
  str0309: "The number of days for delivery must be higher than zero.",
  str0310: "The available quantity entered is greater than the requested quantity.",
  str0311: "An item exists without status definition.",
  str0312: "Note text to be sent to the supplier.",
  str0313: "Add e-mail",
  str0314: "To:",
  str0315: "Complete",
  str0316: "Partial",
  str0317: "Pending",
  str0318: "Rejected",
  str0319: "Disqualified",
  str0320: "Complete (E-mail)",
  str0321: "Partial (E-mail)",
  str0322: "Disqualify this supplier?",
  str0323: "Qualify this supplier?",
  str0324: "E-mail duplicated",
  str0325: "Maximum field size is",
  str0326: "characters",
  str0327: "Maximum field size",
  str0328: "exceeded.",
  str0329: "Attachment(s)",
  str0330: "Invalid e-mail",
  str0331: "New attachment",
  str0332: "File",
  str0333: "By Full Proposal",
  str0334: "By Item",
  str0335: "Valor total médio",
  str0336: "Display suppliers",
  str0337: "Hide suppliers",
  str0338: "Items not answered",
  str0339: "Notice",
  str0340: "Items exist that were not answered by any supplier",
  str0341: "One or more items were not answered by any supplier",
  str0342: "Remove the item(s) from the quotation to continue",
  str0343: "If you click Do not remove, only viewing by item will be available",
  str0344: "Below average",
  str0345: "Above average",
  str0346: "Unit",
  str0347: "Analyze by item",
  str0348: "Remove items",
  str0349: "If you click Yes, only the analysis by item will be available",
  str0350: "If you click Yes, all items selected ( items not served) will be removed from the current quotation.",
  str0351: "Item",
  str0352: "Estimated date",
  str0353: "Valor unitário médio",
  str0354: "Available qty.",
  str0355: "Currency",
  str0356: "Currency Rate",
  str0357: "There are no suppliers for this analysis mode. Use the option by item",
  str0358: "This action cannot be reversed.",
  str0359: "Some items have not been replied by any supplier.",
  str0360: "No complete proposals exist to analyze, continue analyzing per item only, or remove unquoted items?",
  str0361: "Delete quotation",
  str0362: "Are you sure you want to delete the quotation",
  str0363: "The discount entered is greater than the total value of the item.",
  str0364: "Generating documents",
  str0365: "No winning item selected.",
  str0366: "On average",
  str0367: "Confirm the analysis and generate documents with the selected winners?",
  str0368: "Formalize the quotation",
  str0369: "Order by:",
  str0370: "Days",
  str0371: "Price plus taxes",
  str0372: "Taxes",
  str0373: "IPI value",
  str0374: "ICMS value",
  str0375: "ISS value",
  str0376: "Comp. ICMS",
  str0377: "ICMS Solidario value",
  str0378: "DIFAL value",
  str0379: "IPI rate",
  str0380: "ICMS rate",
  str0381: "ISS rate",
  str0382: "Comp. rate",
  str0383: "Values by item",
  str0384: "Percentage by item",
  str0385: "Taxes by item",
  str0386: "Calculate taxes",
  str0387: "Total taxes",
  str0388: "Total values",
  str0389: "Gross value",
  str0390: "Net Value",
  str0391: "Cannot apply discount to a product without value",
  str0392: "Target difal base",
  str0393: "Source Difal",
  str0394: "Target Difal",
  str0395: "Base values",
  str0396: "IPI Base",
  str0397: "ICMS Base",
  str0398: "Total items value",
  str0399: "ICMS Solidario base",
  str0400: "Taxes calculated successfully.",
  str0401: "Total item value",
  str0402: "No quotation item was answered",
  str0403: "The quotation does not serve 100% of the items (quantity available is lower than the one requested, or zeroed unit value).",
  str0404: "The quotation serves 100% of the items.",
  str0405: "Quotation rejected by supplier.",
  str0406: "Supplier's quotation disqualified.",
  str0407: "Quotation replied by e-mail and does not serve 100% of the items (quantity available is lower than requested, or zeroed unit value).",
  str0408: "Quotation replied by e-mail, serves 100% of the items.",
  str0409: "This quotation does not have an attachment.",
  str0410: "Only the attachments entered when generating the quotation will be sent, no new files can be attached to the e-mail.",
  str0411: "PC/CT Note",
  str0412: "Item already selected!",
  str0413: "We found an issue when sending the e-mail. Check the Workflow configurations!",
  str0414: "Enter the justification for the items.",
  str0415: "The following items do not have the lowest value; thus, the choice must be justified.",
  str0416: "Important",
  str0417: "The proposal selected does not have the lowest value; thus, the choice must be justified.",
  str0418: "Enter a justification.",
  str0419: "Add note",
  str0420: "Justification",
  str0421: "All",
  str0422: "Type of status",
  str0423: "Proposal",
  str0424: "Customized fields",
  str0425: "Taxes by item",
  str0426: "Other fields",
  str0427: "New workflow proposal",
  str0428: "A new proposal will be generated. All values already entered will be set to zero",
  str0429: "Quant. products",
  str0430: "Quant. suppliers",
  str0431: "Display history of proposals",
  str0432: "Hide history of proposals",
  str0433: "New manual proposal",
  str0434: "A new proposal will be generated; by clicking confirm, you will be redirected to the next screen.",
  str0435: "Issue Date",
  str0436: "Inconsistency in field E-mail of supplier",
  str0437: "Expenses",
  str0438: "Insurance",
  str0439: "Product Group Code",
  str0440: "Product Group Description",
  str0441: "Enter product group",
  str0442: "Enter description of product group",
  str0443: "Different Product Groups",
  str0444: "Validate product group?",
  str0445: "Allow selecting only items of same product group (use only the group of first item selected).",
  str0446: "You can only select items without product group.",
  str0447: "You can only select items of product group",
  str0448: "Quotation Map",
  str0449: "Other values",
  str0450: "Type of inflow",
  str0451: "Code",
  str0452: "Tax code",
  str0453: "Generate trade note",
  str0454: "Update stock",
  str0455: "Default text",
  str0456: "Delete proposal",
  str0457: "The current proposal will be deleted, continue?",
  str0458: "Average values",
  str0459: "Uni. Average",
  str0460: "The maximum discount percentage allowed is",
  str0461: "The discount entered is greater than the total quotation value.",
  str0462: "Balance",
  str0463: "Supplier already existing",
  str0464: "To add a participant in this quotation request, enter the data below.",
  str0465: "If a purchase order is made with this participant, the full registration will be needed.",
  str0466: "Add supplier",
  str0467: "Supplier not registered",
  str0468: "The quotation had a non-registered participant as the winner. Register them now?",
  str0469: "If negative, this quotation will not be formalized",
  str0470: "Session expired. Log in again.",
  str0471: "Suppliers File",
  str0472: "Others",
  str0473: "City Code",
  str0474: "CrtCd",
  str0475: "Branch",
  str0476: "Account",
  str0477: "Condition",
  str0478: "Type",
  str0479: "The EIN entered must be changed.",
  str0480: "The SSN entered must be changed.",
  str0481: "EIN already registered",
  str0482: "SSN already registered",
  str0483: "No. of Replies",
  str0484: "Generate documents",
  str0485: "Formalization",
  str0486: "Answered Prop.",
  str0487: "Discarded Prop.",
  str0488: "Proposal Formalization",
  str0489: "Document type:",
  str0490: "Contract",
  str0491: "Purchase Order",
  str0492: "Single Contract",
  str0493: "Separate Contracts",
  str0494: "Next contract",
  str0495: "Save contract",
  str0496: "Save contracts",
  str0497: "Add Contract",
  str0498: "Generate a single contract for all suppliers, separating them in spreadsheets, separate contracts for each supplier?",
  str0499: "Proposal Formalization",
  str0500: "Product",
  str0501: "Preference",
  str0502: "The supplier '{0}' has no balance for this product.",
  str0503: "The item '{0}' has no balance.",
  str0504: "The selection of the supplier with best value considers the available quantity and the breakdown of the following values:",
  str0505: "Information",
  str0506: "Calculation",
  str0507: "The supplier does not have stock or does not sell the items quoted.",
  str0508: "Products",
  str0509: "The code of the supplier or business name were already used in this quotation.",
  str0510: "Add Supplier",
  str0511: "Occasional Measurement",
  str0512: "Fixed Contract",
  str0513: "Contact",
  str0514: "New participant",
  str0515: "No supplier found for the store entered.",
  str0516: "Enter the Supplier Code or Business Name field.",
  str0517: "Format of e-mail field invalid.",
  str0518: "Cannot add a new participant because the quotation is out of the receipt deadline.",
  str0519: "Send the quotation to the new participant by e-mail?",
  str0520: "Generate",
  str0521: "Mandatory Fields",
  str0522: "Pending quotation.",
  str0523: "Quotation finished.",
  str0524: "Attachment saved successfully.",
  str0525: "Error saving attachment.",
  str0526: "The currency is mandatory.",
  str0527: "Only suppliers with complete proposals, that is, answering all items, will be listed below.",
  str0528: "Parameter and Files",
  str0529: "Enter work directory of Workflow",
  str0530: "Download the following files and extract them to the aforementioned folder.",
  str0531: "Official documentation for query",
  str0532: "New Purchases Flow",
  str0533: "Server Data",
  str0534: "Enter the public (IP) address or the workflow server",
  str0535: "Enter the workflow server port",
  str0536: "Name of Environment in which the Workflow is executed",
  str0537: "Workflow server Name/IP and Port",
  str0538: "Multiprotocol Port",
  str0539: "Finalization",
  str0540: "Upon confirmation, the data are saved in the database and the system creates an Appserver.ini template file you can copy to your official Appserver.ini, in accordance with your environment rules.",
  str0541: "Success",
  str0542: "The Appserver.ini file below is only a suggestion with the data entered. Adapt the .ini of the actual environment as needed.",
  str0543: "Remember: place the downloaded .html files in the location entered in the work directory field of the Workflow",
  str0544: "E-mail Parameters - buyers",
  str0545: "Enter SMTP server address:",
  str0546: "Enter the SMTP server port:",
  str0547: "Enter POP 3 / IMAP server address:",
  str0548: "Enter POP 3 / IMAP server port:",
  str0549: "Copy text",
  str0550: "AppServer.ini Template",
  str0551: "Configuration - e-mail of the buyer",
  str0552: "Security protocol used in server",
  str0553: "Fill in the name/IP of SMTP server of e-mail in use. If left blank or you lack the information, query the company's technical department.",
  str0554: "Fill in the port of SMTP server of e-mail in use. If left blank or you lack the information, query the company's technical department.",
  str0555: "Fill in the name/IP of POP3/IMAP server of e-mail in use. If left blank or you lack the information, query the company's technical department.",
  str0556: "Fill in the port of POP3/IMAP server of e-mail in use. If left blank or you lack the information, query the company's technical department.",
  str0557: "Authentication protocol type of e-mail server: SSL, TLS or None",
  str0558: "E-mail inbox created.",
  str0559: "Purchaser e-mail account",
  str0560: "Purchaser e-mail",
  str0561: "Name of purchaser to be added to e-mail",
  str0562: "Purchaser e-mail to be added to e-mail - field 'From'.",
  str0563: "Authentication",
  str0564: "User authentication (e-mail account)",
  str0565: "Authentication password (e-mail password)",
  str0566: "SMTP and POP 3/IMAP Servers",
  str0567: "SMTP server address",
  str0568: "SMTP server port",
  str0569: "POP 3/IMAP server address",
  str0570: "POP 3/IMAP server port",
  str0571: "When continuing, a new mailbox is created with the entered information.",
  str0572: "Multiprotocol port (MultiProtocolPort) exists in INI and is active.",
  str0573: "Multiprotocol Port (MultiProtocolPort) does not exist in INI or is inactive (Value 0).",
  str0574: "An error occurred when creating mailbox:",
  str0575: "Enter the directory in which the files created by workflow are stored. For example, if the path goes directly into the Workflow folder, enter only \\workflow.",
  str0576: "If there is a virtual alias or subdirectory for the workflow, as the ABC folder within the Workflow folder, enter \\workflow\\abc.",
  str0577: "PR Code",
  str0578: "Related purchase requests",
  str0579: "Configuration Workflow",
  str0580: "Solidary ICMS and IPI taxes are used as criteria for best price.",
  str0581: "Total without taxes",
  str0582: "Total with taxes",
  str0583: "Best price without taxes",
  str0584: "Best price with taxes",
  str0585: "Generated purchase orders",
  str0586: "Generated Contracts",
  str0587: "Price Quote Details",
  str0588: "PO Number",
  str0589: "Contract Number",
  str0590: "Contract Type",
  str0591: "Value",
  str0592: "Start Date",
  str0593: "Validity",
  str0594: "Show providers linked to the product",
  str0595: "Hide providers linked to the product",
  str0596: "Selection of Supliers x Product",
  str0597: "Selection of Suppliers",
  str0598: "EIN/SSN",
  str0599: "You may also find the above files in the official document's Workflow session.",
  str0600: "Click here",
  str0601: "File downloads",
  str0602: "Request Note",
  str0603: "About the Wizard",
  str0604: "This wizard aims to ease the creation of the workflow used on the NFC to send proposals by e-mail.",
  str0605: "In each stage of the wizard, enter the information requested so that, at the end of the wizard, they are saved into the system, and a file is displayed ",
  str0606: "Example AppServer.ini for comparison and making the adjustments needed in the AppServer.ini file of the environment in which the workflow will be deployed.",
  str0607: "Plus, directions to the SMTP and POP3/IMAP servers used in the organization can be added as default so that each buyer that uses NFC can configure their e-mail autonomously,",
  str0608: "using the e-mail configuration wizard of the buyer.",
  str0609: "Data saved, and AppServer.ini example generated.",
  str0610: "E-mail inbox changed.",
  str0611: "The following issues were found:",
  str0612: "This wizard aims to ease the creation of the e-mail inbox of the buyer used in the NFC Workflow to send proposals by e-mail if the parameter MV_PGCWF is active.",
  str0613: "Enter the information requested in each stage of the wizard. If you have questions in the SMTP and POP3/IMAP servers address stage, contact the technical department of your organization.",
  str0614: "At the end, if the information are correct, the system will create the e-mail inbox of the buyer in the workflow, triggering the proposals through this inbox.",
  str0615: "Notes added to the purchase request. This information will not be sent to suppliers.",
  str0616: "Enter notes to be sent to the suppliers (optional).",
  str0617: "Keep values from the current proposal?",
  str0618: "Buyer code",
  str0619: "Name of the buyer",
  str0620: "Search by buyer",
  str0621: "Quantity to be acquired:",
  str0622: "The value entered ",
  str0623: "is greater than the balance available ",
  str0624: "The Quantity field will be filled in with the available balance of the item.",
  str0625: "The quantity must be greater than zero.",
  str0626: "Purchase Order and/or Contract related to the quotation removed from the system.",
  str0627: "Partially met",
  str0628: "From A - Z",
  str0629: "From Z - A",
  str0630: "Quantity at the Supplier",
  str0631: "Available qty. Supplier",
  str0632: "Next stage",
  str0633: "Previous stage",
  str0634: "Error getting payment terms:",
  str0635: "Select payment terms?",
  str0636: "If you prefer not to select payment terms, all terms enabled for submission in WF will be automatically submitted.",
  str0637: "Centralized Purchase",
  str0638: "Centralizer Branch",
  str0639: "Branch and EIN",
  str0640: "Items from Branches to be centralized",
  str0641: "Items to be centralized",
  str0642: "PC Note",
  str0643: "This table contains all selected items to be migrated to the centralizer branch; that is, the branch logged into.",
  str0644: "Here, all purchase requests are displayed, regardless of branch. That is, all branches of the system are displayed.",
  str0645: "Select the Centralizer Branch",
  str0646: "Centralize",
  str0647: "Try again",
  str0648: "E-mailbox Name:",
  str0649: "Enter the name of the e-mailbox. Use only letters, numbers and underscore.",
  str0650: "By default, the name will be the user's e-mail - containing only letters, numbers and underscore (_) - concealing other characters.",
  str0651: "The name of the e-mailbox is saved only when added. If it already exists, any change to this field is ignored.",
  str0652: "Are you sure that you want to remove the item: ",
  str0653: "Purchaser Filter",
  str0654: "Quotation Items",
  str0655: "Expand View - Requested Products",
  str0656: "Approver Substitution",
  str0657: "Approver",
  str0658: "Substitute",
  str0659: "Substitute and Transfer Permanently",
  str0660: "Select the approver:",
  str0661: "Temporary Transfer",
  str0662: "Absence Period",
  str0663: "All approval groups and documents will be transferred to the permanent substitute approver.",
  str0664: "home screen image",
  str0665: "Document Transfer Image",
  str0666: "Documents No.",
  str0667: "Search by document number",
  str0668: "Select the substitute approver:",
  str0669: "Delivery Authorization",
  str0670: "Partnership Contact",
  str0671: "Warranty Document",
  str0672: "Measurement",
  str0673: "Revision",
  str0674: "Incoming Document",
  str0675: "Request to Warehouse",
  str0676: "Transfer Request",
  str0677: "Agribusiness Document",
  str0678: "Document Transfer",
  str0679: "Do you want to transfer selected documents to the substitute approver?",
  str0680: "Documents",
  str0681: "Transfer the documents meant for the approver to the substitute for a given absence period, which must be set in advance.",
  str0682: "Transfer all approver documents, which are waiting for release, including approval groups to the substitute approver.",
  str0683: "Migrar cotações",
  str0684: "This routine aims to migrate the quotations generated by the routine 'Generate Quotations, Update Quotation and Analyze Quotation' to the ",
  str0685: "New Purchases Flow.",
  str0686: "Enter the start date and the end date of issue to filter quotations to be migrated.",
  str0687: "Attention:",
  str0688: "This action cannot be reversed. The processing will occur in the background.",
  str0689: "Start Date",
  str0690: "End Date",
  str0691: "Receive notification at end of processing?",
  str0692: "Yes",
  str0693: "No",
  str0694: "You need to have a preset e-mail in the environment.",
  str0695: "Do you want to permanently transfer all approver documents to the substitute approver?",
  str0696: "After confirmation, you can query the transferred documents on the list of the substitute approver.",
  str0697: "None",
  str0698: "This e-mailbox is already registered.",
  str0699: "Sending of e-mails and attachments",
  str0700: "Receive notification of reply?",
  str0701: "Notify summary to supplier?",
  str0702: "When the supplier replies to the proposal, you will receive an e-mail notifying that the reply has been sent.",
  str0703: "When replying to the proposal, the supplier will receive an e-mail containing a summary of the items they have replied.",
  str0704: "The Justification must contain only ",
  str0705: " characters.",
  str0706: "Specific Transfer",
  str0707: "Transfer the documents specifically selected to the substitute approver.",
  str0708: "Purchasers",
  str0709: "Define the document types for the approval group:",
  str0710: "Group",
  str0711: "Approvers",
  str0712: "Approval Flow",
  str0713: "Flow Test",
  str0714: "Successfully Finished",
  str0715: "Accounting Entities",
  str0716: "The item",
  str0717: "was not filled in.",
  str0718: "The items",
  str0719: "were not filled in.",
  str0720: "Items with repeated information are not allowed. Check the items",
  str0721: "Fill in the Group and Description fields.",
  str0722: "and",
  str0723: "Define the approval group:",
  str0724: "Will this group use accounting entities?",
  str0725: "Enable accounting entities",
  str0726: "Define the accounting entites for the approval group:",
  str0727: "Add",
  str0728: "Approval Groups",
  str0729: "Search by name or group code",
  str0730: "Purchase Order No.",
  str0731: "Some items require manual intervention, since the best value could not be automatically selected, as some suppliers are offering a quantity smaller than the one requested.",
  str0732: "The items that require attention are listed below:",
  str0733: "Continue",
  str0734: "Click Continue to open a contract preference settings screen and finish adding the contract.",
  str0735: "Wizard - Approval Group",
  str0736: "This step of the Wizard aims to fill in the approval group data. In it, you can set the code, the description, the document types and the accounting entities.",
  str0737: "Delete selected items",
  str0738: "You need to add at least one item to the accounting entities table.",
  str0739: "Set the approvers for the approval group:",
  str0740: "Registered approvers",
  str0741: "Approvers of the approval group",
  str0742: "You need to add at least one approver to continue.",
  str0743: "Unable to select an approver that was already added.",
  str0744: "The code of the leader cannot be equal to that of the approver.",
  str0745: "Fill in all required fields.",
  str0746: "Set the approval flow for the group:",
  str0747: "Set the purchase type linked to the approver:",
  str0748: "This purchase type was already added.",
  str0749: "Fill in the field",
  str0750: "Fill in the blank item before adding a new line.",
  str0751: "Set the document types for the flow test: ",
  str0752: "Approval by document",
  str0753: "Approval by item",
  str0754: "Validate",
  str0755: "Document value",
  str0756: "Click Details to view the flow test: ",
  str0757: "Flow test not generated for this document type.",
  str0758: "Select at least one document type to generate the flow test.",
  str0759: "New Group",
  str0760: "Finish",
  str0761: "Blocked (waiting for other levels)",
  str0762: "Waiting for user release",
  str0763: "Released by user",
  str0764: "Do you want to save the approval group?",
  str0765: "A configuração do grupo de aprovação foi concluída com sucesso.",
  str0766: "Purchase Request",
  str0767: "This modality is not enabled for proposals generated by the Supplier Portal",
  str0768: "Supplier Note",
  str0769: "Supplier Note",
  str0770: "Reply",
  str0771: "Relationship with the Supplier",
  str0772: "We thank you for your interest in this feature!",
  str0773: "Right now it is imperative to understand how supplier relationship management (SRM) works at your company. ",
  str0774: "We prepared a short survey with 5 questions and your help is essential for us to understand the value of SRM for your operation.",
  str0775: "Could you help us? It will not take 5 minutes and we assure you that the answers received are only for internal use.",
  str0776: "We thank you for participating in the Purchases Module evolution process!",
  str0777: "Click ",
  str0778: "to access the survey.",
  str0779: "The sequence of accounting entities entered in the product",
  str0780: "does not exist in the approval group.",
  str0781: "Product Group",
  str0782: "MU",
  str0783: "Warehouse",
  str0784: "Quotation Number",
  str0785: "Item Value",
  str0786: "Request Code",
  str0787: "Search by product code",
  str0788: "Available Qty",
  str0789: "Expected Inflow Qty",
  str0790: "Last Purchase Price",
  str0791: "Last Purchase Date",
  str0792: "Highest Qty Purchased",
  str0793: "Average Time for Delivery",
  str0794: "Pending PCs",
  str0795: "PCs delivered",
  str0796: "Search for Request Code",
  str0797: "Search for Quotation Code",
  str0798: "Search for Supplier Code",
  str0799: "Purchase Requests",
  str0800: "Receive e-mail when supplier(s) reply to the proposal?",
  str0801: "Days late",
  str0802: "Search for Supplier name or code",
  str0803: "First Purchase",
  str0804: "Last Purchase",
  str0805: "Longer Delay (days)",
  str0806: "Supplier Invoice",
  str0807: "Supplied Products",
  str0808: "PCs Late",
  str0809: "Purchase Returns",
  str0810: "Search for Product code or name",
  str0811: "Search for order number",
  str0812: "Suppliers",
  str0813: "Purchase Order Item",
  str0814: "Measurement Item",
  str0815: "Contract Item",
  str0816: "Revision Item",
  str0817: "Export Spreadsheet",
  str0818: "Do you want to generate the Quotation Map spreadsheet?",
  str0819: "Expand View - Quoted Products",
  str0820: "Only registered suppliers with a viewable history will be considered in the History!",
  str0821: "Unregistered suppliers",
  str0822: "Only registered products with a viewable history will be considered in the History!",
  str0823: "My Suppliers",
  str0824: "The Suppliers listed below are from a filter executed via entry point (NFCFILFOR).",
  str0825: "Change Receipt",
  str0826: "Change Date of Receipt",
  str0827: "Código Tributo",
  str0828: "Tributos Genéricos",
  str0829: "Acessibilidade",
  str0830: "Nível de acessibilidade",
  str0831: "Para aplicar as alterações de acessibilidade é necessário fechar e reabrir a rotina.",
  str0832: "Deseja fechar agora?",
  str0833: "Trabalhos não salvos serão perdidos. Salve antes de continuar.",
  str0834: "ATENÇÃO!",
  str0835: "Valor IBS Estadual",
  str0836: "Valor IBS Municipal",
  str0837: "Valor CBS Federal",
  str0838: "Det. Pagamento",
  str0839: "A visualização da cotação não é permitida nessa etapa!",
  str0840: "Visualizar Cotação",
  str0841: "Minhas cotações",
  str0842: "Permite filtrar apenas as cotações associadas ao comprador atual, logado no sistema.",
  str0843: "Status padrão",
  str0844: "A partir da data",
  str0845: "Pesquisa Manual",
  str0846: "Informe um dos seguintes dados: CNPJ, Razão Social, Nome Fantasia ou Código do Fornecedor, para que a busca seja realizada.",
  str0847: "Filtros padrão definidos!",
  str0848: "Salva automaticamente os filtros configurados para cada usuário, de forma individual, e os mantém ativos ao retornar ao sistema.",
  str0849: "Define se a pesquisa ocorrerá manualmente, apenas ao clicar no botão ‘Pesquisar’, ou automaticamente, conforme o campo de busca for preenchido.",
  str0850: "Quantidade de registros por página a ser carregado (Padrão: 20)",
  str0851: "Registro por página",
  str0852: "Filtro Padrão",
  str0853: "Cod. Produto",
  str0854: "Não é permitido selecionar solicitações de filiais diferentes em uma mesma cotação.",
  str0855: "Vencedor",
  str0856: "Lote",
  str0857: "Como a cotação está aglutinando solicitações de lotes distintos, o pedido de compra resultante não fará referência ao lote. Confirma a geração da cotação de compra?",
  str0858: "Lotes solicitados (em ",
  str0859: "Pessoa Física",
  str0860: "Pessoa Jurídica",
  str0861: "Outros",
  str0862: "Tipo de fornecedor",
  str0863: "Adicionar CPF/CNPJ",
  str0864: "CPF deve ser informado.",
  str0865: "CNPJ deve ser informado.",
  str0866: "Formato do campo CPF inválido.",
  str0867: "Formato do campo CNPJ inválido.",
  str0868: "Ocultar Itens sem saldo",
  str0869: "Informações Adicionais",
  str0870: "Informações adicionais salvas com sucesso.",
  str0871: "Promover",
  str0872: "Complemento",
  str0873: "Clique para exibir o histórico de compras",
  str0874: "Trazer cotações marcadas?",
  str0875: "Tp. Frete",
  str0876: "Validando o ambiente",
  str0877: "Define se as cotações da análise por item serão marcadas automaticamente com o melhor preço. A preferência permanece salva no perfil do usuário.",
  str0878: "Configuração salva com sucesso!",
  str0879: "Criar filtros",
  str0880: "Esta listagem possui filtros aplicados",
  str0881: "Filtros salvos",
  str0882: "Selecione um filtro",
  str0883: "Manter o filtro ativo?",
  str0884: "Ao habilitar, o filtro será salvo no perfil do usuário e aplicado automaticamente ao entrar na rotina",
  str0885: "Novo critério",
  str0886: "Campo",
  str0887: "Selecione o campo",
  str0888: "Operador",
  str0889: "Expressão",
  str0890: "Selecione a data",
  str0891: "Valor",
  str0892: "Filtro montado",
  str0893: "Limpar filtro",
  str0894: "Nome do filtro",
  str0895: "Informe o nome para salvar",
  str0896: "Salvar alterações",
  str0897: "Cancelar edição",
  str0898: "Aplicar filtro",
  str0899: "Limpar",
  str0900: "Selecione um filtro salvo para manter ativo.",
  str0901: "Filtro configurado com sucesso!",
  str0902: "Selecione um campo.",
  str0903: "Selecione um operador.",
  str0904: "Informe um valor para a expressão.",
  str0905: "Adicione ao menos um critério ao filtro.",
  str0906: "Informe um nome para o filtro.",
  str0907: "Adicione ao menos um critério antes de salvar.",
  str0908: "Filtro",
  str0909: "salvo com sucesso.",
  str0910: "Selecione um filtro para excluir.",
  str0911: "Filtro excluído.",
  str0912: "Selecione um filtro para editar.",
  str0913: "Adicione ao menos um critério antes de salvar.",
  str0914: "Opções",
  str0915: "Pular",
  str0916: "Erro ao executar ação customizada.",
  str0917: "Editando: ",
  str0918: "Clique para gerenciar os anexos",
  str0919: "Abre o banco de conhecimento para incluir, baixar ou excluir documentos",
  str0920: "Em atraso",
  str0921: "Previstos para entrega",
  str0922: "Cod. Fornecedor",
  str0923: "Data Emissão",
  str0924: "Data de entrega",
  str0925: "E-mail Solicit.",
  str0926: "Hist. Alteração Data",
  str0927: "Data de necessidade",
  str0928: "É obrigatório o preenchimento do fornecedor",
  str0929: "Existem preços unitários a serem definidos. Preencha o preço de todos os itens.",
  str0930: "Mandar e-mail fornecedor",
  str0931: "Notificar solicitante",
  str0932: "Alterar data de entrega",
  str0933: "Olá! Gostaríamos de solicitar a confirmação do prazo de entrega do(s) pedido(s) de compra detalhado(s) abaixo, conforme combinado previamente.",
  str0934: "Caso identifique qualquer alteração ou necessidade de ajuste no cronograma, pedimos a gentileza de nos avisar o quanto antes para que possamos adequar nosso planejamento.",
  str0935: "Agradecemos desde já pela parceria e ficamos no aguardo de seu retorno!",
  str0936: "Selecione ao menos um pedido para enviar e-mail ao fornecedor.",
  str0937: "Informe o conteúdo do e-mail.",
  str0938: "Existe(m) fornecedor(es) sem e-mail cadastrado.",
  str0939: "E-mail enviado com sucesso.",
  str0940: "Falha ao enviar o e-mail.",
  str0941: "Selecione ao menos um pedido para enviar e-mail ao solicitante.",
  str0942: "Informe o assunto do e-mail.",
  str0943: "Informe o título do e-mail.",
  str0944: "Informe o conteúdo do e-mail.",
  str0945: "Existe(m) solicitante(es) sem e-mail cadastrado.",
  str0946: "Selecione ao menos um pedido para alterar a data de entrega.",
  str0947: "Informe a nova data de entrega.",
  str0948: "Informe a justificativa da alteração.",
  str0949: "Selecione ao menos um pedido para alterar a data de entrega.",
  str0950: "Não foi possível alterar a data de entrega.",
  str0951: "Data de entrega alterada com sucesso.",
  str0952: "Acompanhamento",
  str0953: "Próximos 3 dias",
  str0954: "Perto da necessidade",
  str0955: "Próximos 7 dias",
  str0956: "Busque pelo número ou apelido do pedido",
  str0957: "Permite filtrar apenas os pedidos associados ao comprador atual, logado no sistema.",
  str0958: "Follow Up",
  str0959: "solicitações",
  str0960: "pedidos",
  str0961: "Incluir",
  str0962: "A nova data será aplicada a ",
  str0963: " pedido(s) selecionado(s).",
  str0964: "A data de entrega não pode ser anterior à data atual.",
  str0965: "Nova data de entrega",
  str0966: "Justificativa",
  str0967: "Histórico da data de entrega",
  str0968: "Nova data",
  str0969: "Data antiga",
  str0970: "Justificativa da troca de data",
  str0971: "Incluir pedido",
  str0972: "Condição de pagamento",
  str0973: "Solicitações selecionadas",
  str0974: "Preço Unit.",
  str0975: "Solicitantes",
  str0976: "Assunto",
  str0977: "Título",
  str0978: "Conteúdo",
  str0979: "Painel do comprador",
  str0980: "Painel do Comprador - Pedidos",
  str0981: "Gr. Compras"
};
